<template>
  <nav>
    <ul class="pagination mt-4 justify-content-center">
      <li
        v-for="pageNumber in totalPages"
        :key="pageNumber"
        class="page-item mx-1"
      >
        <a
          class="page-link"
          :class="{
            'bg-primary': pageNumber === currentPage,
            'bg-primary-light': pageNumber !== currentPage,
          }"
          @click="$emit('fetch-list', pageNumber)"
          href="#"
          :style="{
            color: textColor(pageNumber),
          }"
          >{{ pageNumber }}</a
        >
      </li>
    </ul>
  </nav>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class Paginator extends Vue {
  @Prop() totalPages;
  @Prop() currentPage;

  textColor(pageNumger) {
    return this.currentPage === pageNumger ? 'white !important' : '';
  }
}
</script>
